module.exports = __webpack_public_path__ + "static/img/user_icon.2507ee7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_icon.jpeg
// module id = Qb8B
// module chunks = 1